/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespLayout_viewer = {
    readonly homepage: {
        readonly personalization?: {
            readonly " $fragmentRefs": FragmentRefs<"HpRespPersonalizedCategories_personalization">;
        } | null;
        readonly " $fragmentRefs": FragmentRefs<"HpRespTopHeroBannerModule_homepage" | "HpRespHeroModuleOld_homepage" | "HpRespPromoModulePrimaryOld_homepage" | "HpRespCollectionsModuleOld_homepage" | "HpRespFeaturedModule_homepage" | "HpRespPromoModuleSecondaryOld_homepage" | "HpRespEditorialModuleOld_homepage" | "HpRespShopByModule_homepage" | "HpRespLocationsModule_homepage">;
    } | null;
    readonly user?: {
        readonly " $fragmentRefs": FragmentRefs<"HpRespRecentlyViewedItems_user">;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"HpRespPersonalizedCategories_viewer" | "HpRespLocationsModule_viewer" | "HpRespInformationalContent_viewer">;
    readonly " $refType": "HpRespLayout_viewer";
};
export type HpRespLayout_viewer$data = HpRespLayout_viewer;
export type HpRespLayout_viewer$key = {
    readonly " $data"?: HpRespLayout_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespLayout_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
};
return {
  "kind": "Fragment",
  "name": "HpRespLayout_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "homepageId",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "fetchInitialHomepage",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "homepage",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "rootId",
          "variableName": "homepageId"
        }
      ],
      "concreteType": "Homepage",
      "plural": false,
      "selections": [
        {
          "kind": "Condition",
          "passingValue": true,
          "condition": "fetchInitialHomepage",
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "HpRespTopHeroBannerModule_homepage",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "HpRespHeroModuleOld_homepage",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "HpRespPromoModulePrimaryOld_homepage",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "HpRespCollectionsModuleOld_homepage",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "HpRespFeaturedModule_homepage",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "HpRespPromoModuleSecondaryOld_homepage",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "HpRespEditorialModuleOld_homepage",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "HpRespShopByModule_homepage",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "HpRespLocationsModule_homepage",
              "args": null
            }
          ]
        },
        {
          "kind": "Condition",
          "passingValue": true,
          "condition": "hasUserId",
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "personalization",
              "storageKey": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 3
                },
                {
                  "kind": "Literal",
                  "name": "numItems",
                  "value": 3
                },
                (v0/*: any*/)
              ],
              "concreteType": "PersonalizationModuleConnection",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "HpRespPersonalizedCategories_personalization",
                  "args": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "HpRespPersonalizedCategories_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "HpRespLocationsModule_viewer",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchInitialHomepage",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "HpRespInformationalContent_viewer",
          "args": null
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasUserId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": [
            (v0/*: any*/)
          ],
          "concreteType": "User",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "HpRespRecentlyViewedItems_user",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = 'd7bac01a8dd1107e46f554b9d1a5d1e2';
export default node;
